export const emojiIndex = (message, count) => {
	if (typeof message !== 'string' || !/^%%\d+$/.test(message)) return -1;
	const index = Number(message.slice(2));
	return Number.isInteger(index) && index >= 0 && index < count ? index : -1;
};

export const normalizeChatMessage = (message, settings) => {
	if (typeof message !== 'string') return '';
	const text = message.replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, settings.maxChatLength);
	if (settings.onPoki && emojiIndex(text, settings.numEmojis) < 0) return '';
	return text;
};
